import * as React from "react";
import { IconButton, Collapse } from "@mui/material";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { Media } from "@talentpair/quantic";

/*

  SearchLayout manages the open/closed state for the filters and handles the layout of filters either alongside the results or above them.
  It is (and should remain) entirely unaware of the filters as well as the results.

*/

interface SearchLayoutProps {
  isDesktop: boolean;
  filterTitle: React.ReactNode;
  filters: React.ReactNode;
  results: React.ReactNode;
  className?: null | string;
}
interface SearchLayoutState {
  filtersVisible: boolean;
}

class SearchLayout extends React.Component<SearchLayoutProps, SearchLayoutState> {
  static defaultProps = { className: "", isDesktop: false };

  constructor(props: SearchLayoutProps) {
    super(props);
    // eslint-disable-next-line react/state-in-constructor
    this.state = { filtersVisible: props.isDesktop };
  }

  componentDidUpdate(prevProps: SearchLayoutProps): void {
    if (!prevProps.isDesktop && this.props.isDesktop && !this.state.filtersVisible)
      this.setState({ filtersVisible: true }); // eslint-disable-line react/no-did-update-set-state
  }

  render(): React.ReactNode {
    const { filters, filterTitle, results, isDesktop, className } = this.props;
    const { filtersVisible } = this.state;
    return (
      <div className={`flex-auto flex flex-column items-center ${className || ""}`}>
        <div
          className={`flex ${
            isDesktop ? "col-10 mt3 max-width-4 items-start" : "p3 col-12 flex-column items-stretch"
          }`}
        >
          <div className="card-outline" style={{ width: isDesktop ? "40%" : "100%" }}>
            <div className="flex justify-between items-center grey-border-bottom p2">
              <span className="p2">{filterTitle}</span>
              {!isDesktop ? (
                <IconButton onClick={() => this.setState({ filtersVisible: !filtersVisible })}>
                  <ArrowDropDownIcon
                    className={`rotatable rotatable-${filtersVisible ? "open" : "closed"}`}
                  />
                </IconButton>
              ) : null}
            </div>
            <Collapse in={filtersVisible} timeout={300}>
              {filters}
            </Collapse>
          </div>
          <div
            style={
              isDesktop
                ? { width: "60%", marginTop: 0, paddingLeft: "1rem" }
                : { width: "100%", marginTop: "1rem", paddingLeft: 0 }
            }
          >
            {results}
          </div>
        </div>
      </div>
    );
  }
}

export default (props: Omit<SearchLayoutProps, "isDesktop">): React.ReactElement => (
  <Media>{(isDesktop: boolean) => <SearchLayout {...props} isDesktop={isDesktop} />}</Media>
);

export const _test = { SearchLayout };
